import $ from 'jquery';

$(document).on('turbo:load', () => {
  $('.forge--slider-open').on('click', () => {
    $('.page-sidebar').animate({ width: 'toggle' });
  });
});
